import {CommonModule} from '@angular/common';
import {Component, Input, NgModule, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {DxDrawerModule} from 'devextreme-angular';
import {DxScrollViewModule} from 'devextreme-angular';
import {DxToolbarModule} from 'devextreme-angular';
import {HeaderModule, SideNavigationMenuModule} from 'src/app/shared/components/layout';
import {navigation} from '../../app-navigation';
import {AppInfoService, ScreenService} from '../../shared/services/general';

@Component({
  selector: 'app-side-nav-inner-toolbar',
  templateUrl: './side-nav-inner-toolbar.component.html',
  styleUrls: ['./side-nav-inner-toolbar.component.scss'],
})
export class SideNavInnerToolbarComponent implements OnInit {
  public menuItems = navigation;
  public selectedRoute = '';

  public menuOpened: boolean = false;
  public temporaryMenuOpened = false;

  @Input()
  public title: string = '';

  public menuMode = 'shrink';
  public menuRevealMode = 'expand';
  public minMenuSize = 0;
  public shaderEnabled = false;

  constructor(private screen: ScreenService, private router: Router, public applicationInfo: AppInfoService) {
  }

  public ngOnInit() {
    this.menuOpened = this.screen.sizes['screen-large'];

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }

  public updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = 0;
    this.shaderEnabled = !isLarge;
  }

  public toggleMenu = (e: any) => {
    this.menuOpened = !this.menuOpened;
    e.event.stopPropagation();
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  public async navigationChanged(event: any) {
    const path = event.itemData.path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      if (event.node.selected) {
        pointerEvent.preventDefault();
      } else {
        await this.router.navigate(['/secured/' + path]);
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
  }

  public navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}

@NgModule({
  imports: [
    SideNavigationMenuModule,
    DxDrawerModule,
    HeaderModule,
    DxToolbarModule,
    DxScrollViewModule,
    CommonModule,
  ],
  exports: [SideNavInnerToolbarComponent],
  declarations: [SideNavInnerToolbarComponent],
})
export class SideNavInnerToolbarModule {
}
